import { getCurrentInstance as e, computed as u } from "vue";
const l = (t) => {
  const r = e();
  return u(() => {
    var o, n;
    return (n = (o = r?.proxy) == null ? void 0 : o.$props) == null ? void 0 : n[t];
  });
};
export {
  l as useProp
};
